import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui";
import { FormField } from "@/components/ui";
import { AUTHORITIES } from "@/config/constants";
import { useAppDispatch, useAppSelector } from "@/config/store";
import { hasAnyAuthority } from "@/shared/auth/private-route";
import { Form } from "@/shared/form";
import { saveAccountSettings } from "@/shared/reducers/account.reducer";
import { AuthenticationState } from "@/shared/reducers/authentication";
import { Check, Loader2 } from "lucide-react";
import "moment/locale/it";
import { translate } from "react-jhipster";
import { z } from "zod";

const schema = z.object({
  firstName: z.string().min(1, "Required"),
  lastName: z.string().min(1, "Required"),
});

type FormValues = z.infer<typeof schema>;

const SetUserInfoDialog = () => {
  const dispatch = useAppDispatch();
  const { account } = useAppSelector<AuthenticationState>(
    (state) => state.authentication
  );

  const open =
    hasAnyAuthority(account?.roles ?? [], [AUTHORITIES.ROLE_PARENT]) &&
    (!account?.firstName || !account?.lastName || !account?.email);

  const handleConfirmSuccess = (data: FormValues) => {
    dispatch(
      saveAccountSettings({
        firstName: data.firstName,
        lastName: data.lastName,
      })
    );
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="max-w-md gap-0 p-0" onPointerDownOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader className="border-b border-[var(--color-mockup-border)] px-6 py-4 dark:border-[var(--color-mockup-border)]">
          <DialogTitle className="text-heading-2 font-semibold text-[var(--color-mockup-text)]">
            Completa le informazioni del profilo
          </DialogTitle>
        </DialogHeader>
        <div className="p-6">
          {!account ? (
            <div className="flex items-center justify-center py-8">
              <Loader2 className="h-6 w-6 animate-spin text-primary" />
            </div>
          ) : (
            <Form
              id="set-user-info-form"
              schema={schema}
              onSubmit={handleConfirmSuccess}
              defaultValues={{
                firstName: account.firstName ?? "",
                lastName: account.lastName ?? "",
              }}
              className="flex flex-col gap-4"
            >
              <FormField
                name="firstName"
                label={translate("userManagement.firstName")}
                required
              />
              <FormField
                name="lastName"
                label={translate("userManagement.lastName")}
                required
              />
            </Form>
          )}
        </div>
        <DialogFooter className="border-t border-[var(--color-mockup-border)] px-6 py-4 dark:border-[var(--color-mockup-border)]">
          <Button
            type="submit"
            form="set-user-info-form"
            variant="primary"
            className="inline-flex items-center gap-2"
          >
            <Check className="h-5 w-5" />
            Salva
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SetUserInfoDialog;
